import React, { Component } from 'react';

import Navigation from './Navigation.js';


class Sculpture extends Component {


    constructor(props) {
        super(props);

        this.state = {
            images: []
        }
    }

    componentDidMount() {
        fetch('data.json')
            .then((response) => {
                return response.json()
            })
            .then((json) => {
                this.setState({
                    images: json.images
                })
                window.initShuffle();
                window.initPhotoSwipe();
            });

    }

    render() {
        return (
            <div>
                <Navigation />
                <main className="main-content pt-8 pb-2">
                    <section className="section overflow-hidden py-6 pb-8">
                        <div className="container">
                            <div data-provide="shuffle">
                                <div className="row gap-y gap-2 " data-shuffle="list" data-provide="photoswipe1">
                                    {this.state.images.map((item, index) =>
                                        <div className="col-6 col-lg-3" data-shuffle="item" key={index}>
                                            <a className="portfolio-1 gallery-item" href={"assets/img/images/" + item.img}>
                                                <img src={"assets/img/images/" + item.img} alt={item.title + ' - ' + item.content} className="border" />
                                                <div className="portfolio-detail">
                                                    <h5>{item.title}</h5>
                                                    <p>{item.content}</p>
                                                </div>
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        );
    }
}

export default Sculpture;



// WEBPACK FOOTER //
// ./src/Sculpture.js